/* ==========================================================================
   Digitdeck — Selector de pruebas gratis (carrito)

   Un solo estado (los handles elegidos) alimenta tres vistas: las tarjetas de
   lo elegido, el carrusel corto y la lista del acordeon. Quitar una prueba en
   cualquiera de ellas la quita en todas, porque todas se repintan del mismo
   array.

   El catalogo no tiene tope. La lista arranca con la primera pagina que pinta
   Liquid y sigue creciendo pidiendo trozos a la seccion dd-sample-catalog por
   Section Rendering API. La busqueda va contra el buscador de Shopify, no
   contra lo ya cargado, asi encuentra productos que todavia no se han traido.

   Se persiste en dos atributos del carrito:
     _dd_pruebas  handles, uso interno (el guion bajo lo oculta al cliente)
     Pruebas      titulos legibles, es lo que se lee en el pedido
   ========================================================================== */

(function () {
  'use strict';

  if (window.__ddSamplePicker) return;
  window.__ddSamplePicker = true;

  var SEL = '[data-dd-component="sample-picker"]';
  var SEL_CLEANUP = '[data-dd-sample-cleanup]';
  var SECTION = 'dd-sample-catalog';
  var inFlight = false;
  var cleaning = false;

  /* --- Seleccion huerfana --------------------------------------------------- */

  // Los atributos del carrito sobreviven a vaciarlo. Si luego solo quedan
  // productos que no dan prueba, el selector no se pinta y nadie los limpia: el
  // pedido saldria pidiendo una muestra que el cliente ya no gano. Liquid emite
  // la marca cuando detecta ese estado y aqui se borra de una vez.
  function cleanupStale() {
    if (cleaning) return;
    if (!document.querySelector(SEL_CLEANUP)) return;

    cleaning = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { _dd_pruebas: '', Pruebas: '', _dd_pruebas_manual: '' }
      })
    })
      .catch(function () { /* red caida: se reintenta al siguiente repintado */ })
      .then(function () { cleaning = false; });
  }

  /* --- Estado de la seleccion --------------------------------------------- */

  function readChosen(root) {
    return (root.dataset.ddChosen || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function writeChosen(root, list) {
    root.dataset.ddChosen = list.join(',');
  }

  function limitOf(root) {
    return parseInt(root.dataset.ddLimit, 10) || 0;
  }

  // Titulo e imagen de cada handle salen del propio DOM, pero se indexan una
  // sola vez al aparecer. Recorrer cientos de filas en cada clic no escala.
  function indexNodes(root, nodes) {
    var cat = stateOf(root).cat;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var h = el.dataset.ddHandle;
      if (h && !cat[h]) cat[h] = { title: el.dataset.ddTitle || h, image: el.dataset.ddImage || '', url: el.dataset.ddUrl || '' };
    }
    return cat;
  }

  function catalogOf(root) {
    return stateOf(root).cat;
  }

  /* --- Persistencia -------------------------------------------------------- */

  function persist(root) {
    if (inFlight) return;

    var list = readChosen(root);
    var cat = catalogOf(root);
    var titles = list.map(function (h) { return (cat[h] && cat[h].title) || h; });

    var human = titles.length
      ? (root.dataset.ddNotePrefix + ' ' + titles.join(', ')).trim()
      : root.dataset.ddEmptyText;

    var signature = list.join(',') + '||' + human;
    if (root.dataset.ddSaved === signature) return;

    inFlight = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _dd_pruebas: list.join(','),
          Pruebas: human
        }
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('No se guardaron las muestras.'); return r.json(); })
      .then(function () { root.dataset.ddSaved = signature; })
      .catch(function () { /* red caida: el estado sigue en pantalla y se reintenta al siguiente cambio */ })
      .then(function () {
        inFlight = false;
        // A rapid second click must not be lost while the first save is pending.
        if (root.isConnected && readChosen(root).join(',') !== list.join(',')) persist(root);
      });
  }

  /* --- Pintado -------------------------------------------------------------- */

  function render(root, touched) {
    var list = readChosen(root);
    var limit = limitOf(root);
    var cat = catalogOf(root);

    // El carrito pudo encoger: nunca mas pruebas que unidades.
    if (list.length > limit) {
      list = list.slice(0, limit);
      writeChosen(root, list);
    }

    var full = list.length >= limit;
    root.classList.toggle('is-full', full);

    var count = root.querySelector('[data-dd-count]');
    if (count) count.textContent = list.length;
    var limitText = root.querySelector('[data-dd-limit-text]');
    if (limitText) limitText.textContent = limit;

    var chosenList = root.querySelector('[data-dd-chosen-list]');
    if (chosenList) {
      chosenList.innerHTML = '';
      chosenList.hidden = list.length === 0;
      list.forEach(function (h) {
        var item = cat[h] || { title: h, image: '' };
        var li = document.createElement('li');
        li.className = 'dd-chosen';
        // La imagen y el nombre llevan a la ficha del producto; la X solo quita.
        var productURL = safeURL(item.url), imageURL = safeURL(item.image);
        var tag = productURL ? 'a' : 'span';
        li.innerHTML =
          '<' + tag + ' class="dd-chosen__link"' + (productURL ? ' href="' + escapeAttribute(productURL) + '"' : '') + '>' +
            '<span class="dd-chosen__media">' +
              (imageURL ? '<img src="' + escapeAttribute(imageURL) + '" width="44" height="44" alt="" loading="lazy">' : '') +
            '</span>' +
            '<span class="dd-chosen__copy">' +
              '<span class="dd-chosen__name"></span>' +
              '<span class="dd-chosen__meta">' +
                '<span class="dd-chosen__size"></span>' +
                '<span class="dd-chosen__free"></span>' +
              '</span>' +
            '</span>' +
          '</' + tag + '>' +
          '<button type="button" class="dd-chosen__remove" data-dd-remove aria-label="' + escapeAttribute(root.dataset.ddRemoveLabel || 'Quitar') + '">' +
            '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 3l6 6M9 3l-6 6"/></svg>' +
          '</button>';
        // textContent, no innerHTML: los titulos son datos, no marcado.
        li.querySelector('.dd-chosen__name').textContent = item.title;
        li.querySelector('.dd-chosen__size').textContent = root.dataset.ddSizeLabel || '';
        li.querySelector('.dd-chosen__free').textContent = root.dataset.ddFreeText || '';
        li.querySelector('[data-dd-remove]').dataset.ddHandle = h;
        chosenList.appendChild(li);
      });
    }

    // Miniaturas de la cabecera: se ven solo cuando el bloque esta plegado.
    var minis = root.querySelector('[data-dd-minis]');
    if (minis) {
      minis.innerHTML = '';
      list.slice(0, 3).forEach(function (h) {
        var item = cat[h] || {};
        var node;
        var imageURL = safeURL(item.image);
        if (imageURL) {
          node = document.createElement('img');
          node.src = imageURL;
          node.width = 24; node.height = 24; node.alt = ''; node.loading = 'lazy';
        } else {
          node = document.createElement('span');
          node.textContent = (item.title || h).charAt(0);
        }
        minis.appendChild(node);
      });
      if (list.length > 3) {
        var rest = document.createElement('span');
        rest.textContent = '+' + (list.length - 3);
        minis.appendChild(rest);
      }
    }

    // El estado de "lleno" afecta a TODOS los controles (se habilitan o se
    // deshabilitan), asi que solo entonces hay que barrer el catalogo entero.
    // Un clic normal toca dos elementos, no cuatrocientos.
    var st = stateOf(root);
    if (touched && st.full === full) {
      setControl(root, touched, list.indexOf(touched) > -1, full);
    } else {
      var all = root.querySelectorAll('[data-dd-sample]');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        setControl(root, el.dataset.ddHandle, list.indexOf(el.dataset.ddHandle) > -1, full, el);
      }
    }
    st.full = full;
  }

  // Un handle puede estar en dos sitios a la vez (carrusel y lista).
  function setControl(root, handle, on, full, known) {
    var nodes = known ? [known] : root.querySelectorAll('[data-dd-handle="' + cssEscape(handle) + '"][data-dd-sample]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      el.disabled = !on && full;
    }
  }

  function cssEscape(v) {
    return String(v).replace(/["\\]/g, '\\$&');
  }

  function safeURL(value) {
    if (!value) return '';
    try {
      var url = new URL(value, location.href);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
    } catch (error) { return ''; }
  }

  function escapeAttribute(v) {
    return String(v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function toggle(root, handle) {
    var list = readChosen(root);
    var at = list.indexOf(handle);

    if (at > -1) {
      list.splice(at, 1);
    } else {
      if (list.length >= limitOf(root)) return;
      list.push(handle);
    }

    writeChosen(root, list);
    render(root, handle);
    persist(root);
  }

  /* --- Catalogo: paginacion y busqueda -------------------------------------- */

  function stateOf(root) {
    if (!root.__dd) {
      root.__dd = {
        collections: (root.dataset.ddCollections || '').split(',').filter(Boolean),
        colIndex: 0,
        /* #226 — antes era 1 ("Liquid ya pinto la pagina 1"): cierto cuando la
           semilla server-side eran 50 filas = una pagina entera del catalogo
           (dd-sample-catalog pagina de 50). Ahora la semilla son 12, asi que
           el primer chunk debe pedir la pagina 1 completa — `page: 0` hace
           que chunkUrl pida page=1 — y el dedupe de `seen` (abajo) absorbe
           el solape con las 12 ya pintadas. Sin este cambio, los productos
           13-50 se saltarian. */
        page: 0,
        mode: 'browse',
        term: '',
        busy: false,
        done: false,
        seen: {},
        cat: {},
        full: null
      };
      root.querySelectorAll('[data-dd-row] [data-dd-handle]').forEach(function (el) {
        root.__dd.seen[el.dataset.ddHandle] = true;
      });
    }
    return root.__dd;
  }

  function chunkUrl(root, st) {
    if (st.mode === 'search') {
      return '/search?q=' + encodeURIComponent(st.term) +
             '&type=product&options[prefix]=last' +
             '&section_id=' + SECTION + '&page=' + (st.page + 1);
    }
    var handle = st.collections[st.colIndex];
    if (!handle) return null;
    return '/collections/' + encodeURIComponent(handle) +
           '?section_id=' + SECTION + '&page=' + (st.page + 1);
  }

  function setBusy(root, busy) {
    var more = root.querySelector('[data-dd-more]');
    if (!more) return;
    more.classList.toggle('is-busy', busy);
    more.disabled = busy;
  }

  function setDone(root, done, emptyMessage) {
    var more = root.querySelector('[data-dd-more]');
    if (more) more.hidden = done;
    var status = root.querySelector('[data-dd-status]');
    if (status) {
      status.hidden = !emptyMessage;
      status.textContent = emptyMessage || '';
    }
  }

  function loadMore(root) {
    var st = stateOf(root);
    if (st.busy || st.done) return;

    var url = chunkUrl(root, st);
    if (!url) { st.done = true; setDone(root, true); return; }

    st.busy = true;
    setBusy(root, true);

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var list = root.querySelector('[data-dd-list]');
        if (!html || !list) throw new Error('sin contenido');

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var chunk = doc.querySelector('[data-dd-chunk]');
        var rows = chunk ? chunk.querySelectorAll('[data-dd-row]') : [];

        // Un solo insert en el DOM en vez de uno por fila.
        var frag = document.createDocumentFragment();
        var fresh = [];
        var added = 0;
        rows.forEach(function (row) {
          var btn = row.querySelector('[data-dd-handle]');
          var h = btn && btn.dataset.ddHandle;
          if (!h || st.seen[h]) return;   // el mismo perfume puede estar en varias categorias
          st.seen[h] = true;
          frag.appendChild(row);
          fresh.push(btn);
          added++;
        });
        if (added) {
          var end = list.querySelector('[data-dd-end]');
          if (end) list.insertBefore(frag, end);
          else list.appendChild(frag);
          indexNodes(root, fresh);
        }

        st.page++;
        var hasNext = chunk && chunk.dataset.ddNext;

        if (!hasNext) {
          if (st.mode === 'search') {
            st.done = true;
          } else {
            // Se acabo esta categoria: seguimos con la siguiente.
            st.colIndex++;
            st.page = 0;
            if (st.colIndex >= st.collections.length) st.done = true;
          }
        }

        setDone(root, st.done, (st.mode === 'search' && !list.querySelectorAll('[data-dd-row]').length)
          ? (root.dataset.ddNoResults || 'Ningún perfume coincide con tu búsqueda.')
          : '');

        render(root);

        // Si el trozo vino entero duplicado y aun queda catalogo, seguimos.
        if (added === 0 && !st.done) {
          st.busy = false;
          setBusy(root, false);
          loadMore(root);
          return;
        }
      })
      .catch(function () {
        st.done = true;
        setDone(root, true);
      })
      .then(function () {
        st.busy = false;
        setBusy(root, false);
      });
  }

  function resetList(root, mode, term) {
    var st = stateOf(root);
    var list = root.querySelector('[data-dd-list]');
    if (list) {
      // Vaciamos las filas pero conservamos el pie: lleva el boton y el sensor.
      var rows = list.querySelectorAll('[data-dd-row]');
      for (var i = 0; i < rows.length; i++) rows[i].remove();
    }
    st.mode = mode;
    st.term = term || '';
    st.colIndex = 0;
    st.page = 0;
    st.done = false;
    st.busy = false;
    st.seen = {};
    st.full = null;   // fuerza un barrido completo tras repoblar
    setDone(root, false, '');
    loadMore(root);
  }

  /* --- Acordeon animado ----------------------------------------------------- */

  function setupDetails(el) {
    if (el.dataset.ddReady === '1') return;
    el.dataset.ddReady = '1';
    el.classList.add('is-animated');
    if (el.open) el.classList.add('is-open');

    var summary = el.querySelector(':scope > summary');
    var panel = el.querySelector(':scope > .dd-picker__panel');
    if (!summary || !panel) return;

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      if (!el.open) {
        el.open = true;
        // Reflow sincrono en vez de requestAnimationFrame: rAF no dispara en
        // pestanas ocultas ni sin compositor y el panel se quedaria cerrado.
        void panel.offsetHeight;
        el.classList.add('is-open');
        return;
      }

      el.classList.remove('is-open');
      var done = false;
      var close = function () { if (!done) { done = true; el.open = false; } };
      panel.addEventListener('transitionend', function handler(ev) {
        if (ev.propertyName !== 'grid-template-rows') return;
        panel.removeEventListener('transitionend', handler);
        close();
      });
      setTimeout(close, 460);
    });
  }

  function openDetails(root) {
    var el = root.querySelector('.dd-picker__details');
    if (!el || el.open) return;
    var panel = el.querySelector(':scope > .dd-picker__panel');
    el.open = true;
    if (panel) void panel.offsetHeight;
    el.classList.add('is-open');
  }


  /* --- Carrusel: flechas y carga automatica de la lista --------------------- */

  /* --- Arrastre con el raton ------------------------------------------------ */

  // Puerto vanilla del patron del Carousel compartido (memoria
  // carousel-drag-snap-fight). Escribir scrollLeft con `scroll-snap-type:
  // mandatory` puesto pelea con el navegador, que tira la pista de vuelta a la
  // linea de snap a media pasada: se siente a tirones. Asi que el snap se
  // apaga durante el gesto y al soltar se aterriza en una linea de snap con UN
  // muelle sembrado con la velocidad de salida. Nada de inercia con
  // modifyTarget: su muelle de aterrizaje es duro y corta la animacion.
  var DRAG_PROYECCION = 0.12;   // segundos de momento proyectado
  var DRAG_FLICK = 350;         // px/s: por encima, un golpe decidido cambia de tarjeta
  var DRAG_UMBRAL = 6;          // px antes de tratarlo como arrastre y no como clic

  // Zancada = tarjeta + hueco. La usan el aterrizaje del arrastre y las flechas,
  // asi que ambos caen siempre en la misma linea de snap.
  function pasoDe(rail) {
    var item = rail.querySelector('li');
    if (!item) return 104;
    var estilos = getComputedStyle(rail);
    var hueco = parseFloat(estilos.columnGap || estilos.gap) || 0;
    return Math.round(item.getBoundingClientRect().width + hueco) || 104;
  }

  function setupDrag(rail, refresh) {
    if (rail.dataset.ddDrag === '1') return;
    rail.dataset.ddDrag = '1';

    var activo = false, arrastro = false;
    var xInicial = 0, scrollInicial = 0;
    var ultimoX = 0, ultimoT = 0, velocidad = 0;   // px/ms
    var animacion = null;

    function cortarAnimacion() {
      if (!animacion) return;
      cancelAnimationFrame(animacion.raf);
      clearTimeout(animacion.salvavidas);
      animacion = null;
    }

    // Muelle sobreamortiguado (ratio ~1.1): una sola deceleracion, sin rebote.
    function aterrizar(desde, destino, vSegundo) {
      var x = desde, v = vSegundo, k = 100, c = 22, ultimo = null, hecho = false;

      function fin() {
        if (hecho) return;
        hecho = true;
        rail.scrollLeft = destino;
        // El destino es multiplo del paso, o sea una linea de snap: devolver el
        // snap aqui no provoca ningun salto.
        rail.style.scrollSnapType = '';
        cortarAnimacion();
        refresh();
      }

      function tic(t) {
        if (hecho) return;
        if (ultimo === null) ultimo = t;
        var dt = Math.min((t - ultimo) / 1000, 0.032);
        ultimo = t;
        var a = -k * (x - destino) - c * v;
        v += a * dt;
        x += v * dt;
        rail.scrollLeft = x;
        refresh();
        if (Math.abs(x - destino) < 0.4 && Math.abs(v) < 8) { fin(); return; }
        animacion.raf = requestAnimationFrame(tic);
      }

      // rAF no corre en pestanas ocultas ni sin compositor: sin esto el riel se
      // quedaria con el snap desactivado a medio camino.
      animacion = { raf: requestAnimationFrame(tic), salvavidas: setTimeout(fin, 1200) };
    }

    var punteroCapturado = null, punteroId = null;

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;   // el tactil ya paneaba solo
      cortarAnimacion();
      // Por si un gesto anterior se quedo a medias (se solto el raton fuera de
      // la ventana): sin esto el riel se queda sin snap para siempre.
      rail.style.scrollSnapType = '';
      activo = true;
      arrastro = false;
      xInicial = ultimoX = e.clientX;
      scrollInicial = rail.scrollLeft;
      ultimoT = e.timeStamp;
      velocidad = 0;
      punteroId = e.pointerId;
      // OJO: la captura NO se toma aqui. Con el puntero capturado el navegador
      // redirige el `click` al elemento que captura, asi que el clic llegaba al
      // riel y no a la tarjeta: dejaba de poder elegirse ninguna prueba. Se
      // captura solo cuando el gesto ya es un arrastre de verdad.
    });

    window.addEventListener('pointermove', function (e) {
      if (!activo) return;
      var dx = e.clientX - xInicial;

      if (!arrastro) {
        if (Math.abs(dx) < DRAG_UMBRAL) return;   // aun puede ser un clic
        arrastro = true;
        rail.style.scrollSnapType = 'none';       // libera el gesto
        document.body.style.userSelect = 'none';
        // Ya es un arrastre: ahora si conviene capturar, para que soltar fuera
        // de la ventana no deje el riel sin snap. Como el gesto ya dejo de ser
        // un clic, redirigir el click al riel es justo lo que queremos.
        if (punteroId !== null) {
          try { rail.setPointerCapture(punteroId); punteroCapturado = punteroId; } catch (err) {}
        }
      }

      var dt = e.timeStamp - ultimoT;
      if (dt > 0) velocidad = (e.clientX - ultimoX) / dt;
      ultimoX = e.clientX;
      ultimoT = e.timeStamp;

      rail.scrollLeft = scrollInicial - dx;
      refresh();
    });

    function soltar(e) {
      if (!activo) return;
      activo = false;
      document.body.style.userSelect = '';
      if (punteroCapturado !== null) {
        try { rail.releasePointerCapture(punteroCapturado); } catch (err) {}
        punteroCapturado = null;
      }
      if (!arrastro) { rail.style.scrollSnapType = ''; return; }

      // Se invierte el signo: mover el raton a la izquierda avanza el scroll.
      var vSegundo = -velocidad * 1000;
      if (e && e.timeStamp - ultimoT > 90) vSegundo = 0;   // se quedo quieto antes de soltar

      var salto = pasoDe(rail);
      var tope = Math.max(0, rail.scrollWidth - rail.clientWidth);
      var desde = rail.scrollLeft;
      var destino = Math.round((desde + vSegundo * DRAG_PROYECCION) / salto) * salto;

      // Un golpe decidido siempre cambia de tarjeta, aunque haya recorrido poco.
      if (Math.abs(vSegundo) >= DRAG_FLICK) {
        var base = Math.round(desde / salto) * salto;
        if (destino === base) destino = base + (vSegundo > 0 ? salto : -salto);
      }

      destino = Math.max(0, Math.min(tope, destino));
      aterrizar(desde, destino, vSegundo);
    }

    window.addEventListener('pointerup', soltar);
    window.addEventListener('pointercancel', soltar);

    // Mata el fantasma nativo al arrastrar imagenes o enlaces.
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Si hubo arrastre, el clic de cierre no debe elegir la tarjeta de debajo.
    rail.addEventListener('click', function (e) {
      if (!arrastro) return;
      e.preventDefault();
      e.stopPropagation();
      arrastro = false;
    }, true);
  }

  function setupRail(root) {
    var rail = root.querySelector('.dd-picker__rail');
    var nav = root.querySelector('[data-dd-rail-nav]');
    if (!rail || !nav) return;

    var prev = nav.querySelector('[data-dd-rail-prev]');
    var next = nav.querySelector('[data-dd-rail-next]');

    // Una tarjeta por clic, no una pagina. Es la segunda mitad de
    // carousel-agency-rules: saltarse varias tarjetas de golpe se lee como un
    // fallo. El paso es tarjeta + hueco, nunca el ancho de la pista.
    function step() {
      return pasoDe(rail);
    }

    function refresh() {
      var max = rail.scrollWidth - rail.clientWidth;
      // Sin nada que paginar la fila se oculta pero conserva su espacio.
      nav.classList.toggle('is-static', max < 4);
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
    }

    // Movemos a una posicion calculada y actualizamos el estado EN EL ACTO.
    // Depender solo del evento 'scroll' es fragil: llega tarde o no llega si
    // la pestana esta en segundo plano, y las flechas se quedan mal pintadas.
    function nudge(dir) {
      var max = rail.scrollWidth - rail.clientWidth;
      var target = Math.max(0, Math.min(max, rail.scrollLeft + dir * step()));
      rail.scrollTo({ left: target, behavior: 'smooth' });
      if (prev) prev.disabled = target <= 2;
      if (next) next.disabled = target >= max - 2;
      setTimeout(refresh, 400);
    }

    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    // La rueda NO se toca: se mueve arrastrando, como el resto de carruseles
    // de la casa. Secuestrarla hacia el eje horizontal dejaba al cliente sin
    // poder bajar por el carrito con el raton encima del riel.
    setupDrag(rail, refresh);

    rail.addEventListener('scroll', refresh, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(rail);
    refresh();
  }

  // Sensor al final de la lista: al asomarse, trae la pagina siguiente sin
  // que el cliente tenga que buscar el boton.
  function setupAutoLoad(root) {
    if (!window.IntersectionObserver) return;
    var list = root.querySelector('[data-dd-list]');
    var end = root.querySelector('[data-dd-end]');
    if (!list || !end) return;

    new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) loadMore(root);
    }, { root: list, rootMargin: '120px' }).observe(end);

    // Respaldo: IntersectionObserver necesita que el navegador calcule
    // intersecciones, y eso no ocurre en pestanas sin pintar. El scroll
    // llano cubre ese hueco; el boton sigue estando para el caso extremo.
    list.addEventListener('scroll', function () {
      if (list.scrollTop + list.clientHeight >= list.scrollHeight - 140) loadMore(root);
    }, { passive: true });
  }

  /* --- Arranque y re-render del drawer -------------------------------------- */

  function boot(root) {
    if (root.dataset.ddBooted !== '1') {
      root.dataset.ddBooted = '1';

      root.querySelectorAll('details').forEach(setupDetails);
      setupRail(root);
      setupAutoLoad(root);

      var search = root.querySelector('[data-dd-search]');
      var clear = root.querySelector('[data-dd-search-clear]');
      if (search) {
        var timer = null;
        search.addEventListener('input', function () {
          var term = this.value.trim();
          if (clear) clear.hidden = !term;
          // Buscar sin ver los resultados no sirve de nada: abrimos la lista.
          if (term) openDetails(root);
          clearTimeout(timer);
          // Antirebote: una peticion cuando deja de escribir, no una por tecla.
          timer = setTimeout(function () {
            resetList(root, term ? 'search' : 'browse', term);
          }, 350);
        });
      }
      if (clear) {
        clear.addEventListener('click', function () {
          if (!search) return;
          search.value = '';
          clear.hidden = true;
          search.focus();
          resetList(root, 'browse', '');
        });
      }

      var more = root.querySelector('[data-dd-more]');
      if (more) more.addEventListener('click', function () { loadMore(root); });

      // Las fichas de lo ya elegido van PRIMERO: son las unicas que cubren un
      // handle que no esta en la tanda pintada del catalogo. Sin esto se
      // pintaria el slug sin imagen y ese slug acabaria en la nota del pedido.
      indexNodes(root, root.querySelectorAll('[data-dd-seed]'));
      indexNodes(root, root.querySelectorAll('[data-dd-sample]'));
    }
    render(root);
    persist(root);
  }

  function bootAll() {
    cleanupStale();
    document.querySelectorAll(SEL).forEach(boot);
  }

  document.addEventListener('click', function (e) {
    var origen = e.target;
    if (!origen || !origen.closest) return;

    var root = origen.closest(SEL);
    if (!root) return;

    var remove = origen.closest('[data-dd-remove]');
    if (remove) { e.preventDefault(); toggle(root, remove.dataset.ddHandle); return; }

    var sample = origen.closest('[data-dd-sample]');

    // Red de seguridad: si algo captura el puntero, el navegador redirige el
    // click al elemento que captura (el riel) en vez de a la tarjeta, y
    // entonces no se podia elegir ninguna prueba. Cuando el click cae dentro
    // del selector pero no resuelve a una tarjeta, se mira que hay realmente
    // bajo el cursor.
    if (!sample && e.clientX >= 0 && e.clientY >= 0) {
      var debajo = document.elementFromPoint(e.clientX, e.clientY);
      if (debajo && debajo.closest && root.contains(debajo)) {
        sample = debajo.closest('[data-dd-sample]');
      }
    }

    if (sample && !sample.disabled) { e.preventDefault(); toggle(root, sample.dataset.ddHandle); }
  });

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        // Tambien la marca de limpieza: sin el selector en pantalla no habria
        // ningun nodo que disparase el observador y la nota huerfana se quedaria.
        if ((node.matches && (node.matches(SEL) || node.matches(SEL_CLEANUP))) ||
            (node.querySelector && (node.querySelector(SEL) || node.querySelector(SEL_CLEANUP)))) { bootAll(); return; }
      }
    }
  });

  function start() {
    bootAll();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
